import classNames from 'classnames';

import styles from './_index.module.scss';

export interface LoaderProps extends React.HTMLAttributes<HTMLDivElement> {
  isCentered?: boolean;
}

const Loader = ({ isCentered }: LoaderProps) => {
  return (
    <div className={classNames(styles[`loader`], { [styles['is-centered']]: isCentered })}>
      {[...Array(4)].map((bar, index) => (
        <div key={`loader-${index}`}>
          <div />
        </div>
      ))}
    </div>
  );
};

export default Loader;
